import { render, staticRenderFns } from "./PulseIcon.vue?vue&type=template&id=1800c4f3&scoped=true"
var script = {}
import style0 from "./PulseIcon.vue?vue&type=style&index=0&id=1800c4f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1800c4f3",
  null
  
)

export default component.exports